import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function SpaceCreateHeader() {
  const navigate = useNavigate();

  return (
    <div style={{ background: 'white', borderBottom: '2px solid #f0f0f0', padding: '1.5rem 2rem' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <button
            onClick={() => navigate('/spaces')}
            style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', background: 'transparent', color: '#00758d', border: '2px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', fontSize: '0.9rem', fontWeight: 600, transition: 'all 0.2s ease' }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#00758d'; e.currentTarget.style.background = 'rgba(0,117,141,0.05)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#e5e7eb'; e.currentTarget.style.background = 'transparent'; }}
          >
            <ArrowLeft size={16} /> Retour
          </button>
          <div>
            <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#00303c', margin: 0 }}>Créer un nouvel espace</h1>
            <p style={{ fontSize: '0.85rem', color: '#666', margin: '0.25rem 0 0' }}>Renseignez les informations de base, puis configurez les modules</p>
          </div>
        </div>
      </div>
    </div>
  );
}
